// Router ของโหมด Firebase: ชื่อ action เดียวกับ gs/Router.gs -> ฟังก์ชันฝั่ง client
//  a = none | user | super   (super = ต้องเป็น super_user จาก PaymentBroker profile)
import { err, nowIso, clearAllCaches } from "./core";
import { authenticate } from "./auth";
import * as eco from "./economy";
import * as chat from "./chat";
import * as ct from "./content";
import * as ad from "./admin";
import * as ai from "./ai";
import { runSeed } from "./seed";

const A = {};
const def = (name, a, fn) => {
  A[name] = { a, fn };
};

def("ping", "none", async () => ({ ok: true, time: nowIso(), version: "fb-1.0.0" }));
def("setup", "super", async () => {
  const r = await runSeed();
  clearAllCaches();
  return r;
});

// ผู้ใช้
def("bootstrap", "user", ct.bootstrap);
def("me.get", "user", ct.meGet);
def("me.update", "user", ct.meUpdate);
def("profile.get", "user", ct.profileGet);
def("coins.history", "user", eco.coinsHistory);
def("notifications.list", "user", ct.notificationsList);
def("notifications.read", "user", ct.notificationsRead);
def("upload", "user", ct.upload);
def("terms.accept", "user", ct.termsAccept);
def("creators.list", "user", ct.creatorsList);
def("rankings.overview", "user", ct.rankingsOverview);

// ตัวละคร / AI
def("tags.list", "user", ct.tagsList);
def("characters.list", "user", ct.charactersList);
def("characters.get", "user", ct.charactersGet);
def("characters.byCode", "user", ct.charactersByCode);
def("gifts.ranking", "user", ct.giftsRanking);
def("characters.mine", "user", ct.charactersMine);
def("characters.save", "user", ct.charactersSave);
def("characters.archive", "user", ct.charactersArchive);
def("ai.characterDraft", "user", ai.aiCharacterDraft);
def("ai.search", "user", ai.aiSearch);

// persona / scenario / จักรวาล
def("personas.list", "user", ct.personasList);
def("personas.save", "user", ct.personasSave);
def("personas.delete", "user", ct.personasDelete);
def("scenarios.list", "user", ct.scenariosList);
def("scenarios.save", "user", ct.scenariosSave);
def("scenarios.delete", "user", ct.scenariosDelete);
def("universes.list", "user", ct.universesList);
def("universes.get", "user", ct.universesGet);
def("universes.save", "user", ct.universesSave);

// แชท
def("chats.list", "user", chat.chatsList);
def("chat.create", "user", chat.chatCreate);
def("chat.get", "user", chat.chatGet);
def("chat.update", "user", chat.chatUpdate);
def("chat.delete", "user", chat.chatDelete);
def("messages.list", "user", chat.messagesList);
def("chat.send", "user", chat.chatSend);
def("chat.regenerate", "user", chat.chatRegenerate);
def("message.edit", "user", chat.messageEdit);
def("message.delete", "user", chat.messageDelete);
def("message.react", "user", chat.messageReact);
def("memory.get", "user", chat.memoryGet);
def("memory.save", "user", chat.memorySave);

// คอยน์ / VIP
def("packages.list", "user", eco.packagesList);
def("models.list", "user", eco.modelsList);
def("topup.init", "user", eco.topupInit);
def("topup.confirm", "user", eco.topupConfirm);
def("topups.mine", "user", eco.topupsMine);
def("pricing.get", "user", eco.pricingGet);
def("creditPack.init", "user", eco.creditPackInit);
def("creditPack.confirm", "user", eco.creditPackConfirm);
def("creditPack.history", "user", eco.creditHistory);
def("checkin.status", "user", eco.checkinStatus);
def("checkin.claim", "user", eco.checkinClaim);
def("promo.redeem", "user", eco.promoRedeem);
def("referral.info", "user", eco.referralInfo);
def("referral.apply", "user", eco.referralApply);
def("vip.status", "user", eco.vipStatus);
def("vip.claimMonthly", "user", eco.vipClaimMonthly);
def("gifts.list", "user", eco.giftsList);
def("gift.send", "user", chat.giftSend);

// โซเชียล
def("like.toggle", "user", ct.likeToggle);
def("likes.mine", "user", ct.likesMine);
def("follow.toggle", "user", ct.followToggle);
def("comments.list", "user", ct.commentsList);
def("comment.add", "user", ct.commentAdd);
def("comment.delete", "user", ct.commentDelete);
def("posts.list", "user", ct.postsList);
def("post.add", "user", ct.postAdd);
def("post.delete", "user", ct.postDelete);
def("report.create", "user", ct.reportCreate);

// super_user
def("admin.users.list", "super", ad.adminUsersList);
def("admin.users.get", "super", ad.adminUsersGet);
def("admin.users.ban", "super", ad.adminUsersBan);
def("admin.users.adjustCoins", "super", ad.adminAdjustCoins);
def("admin.characters.list", "super", ad.adminCharactersList);
def("admin.characters.review", "super", ad.adminCharactersReview);
def("admin.config.list", "super", ad.adminConfigList);
def("admin.config.save", "super", ad.adminConfigSave);
def("admin.config.remove", "super", ad.adminConfigRemove);
def("admin.reports.list", "super", ad.adminReportsList);
def("admin.reports.resolve", "super", ad.adminReportsResolve);
def("admin.topups.list", "super", ad.adminTopupsList);
def("admin.stats", "super", ad.adminStats);
def("admin.settings.get", "super", ad.adminSettingsGet);
def("admin.settings.set", "super", ad.adminSettingsSet);
def("admin.cache.clear", "super", ad.adminCacheClear);

export const FB_ACTIONS = Object.keys(A);

/** เรียก action — คืน data หรือ throw Error ที่มี .code (รูปแบบเดียวกับ gsClient) */
export async function fbCall(action, params = {}) {
  const d = A[action];
  if (!d) throw err("unknown_action", "ไม่รู้จัก action: " + (action || "(ว่าง)"));
  const ctx = d.a === "none" ? null : await authenticate();
  if (d.a === "super" && !ctx.isSuper) throw err("forbidden", "ต้องเป็น super_user เท่านั้น");
  const out = await d.fn(params || {}, ctx);
  return out === undefined ? null : JSON.parse(JSON.stringify(out)); // ตัดการอ้างอิงร่วมกับ cache
}
